import React from 'react';
import { Spinner } from 'react-bootstrap';

const PageSpinner = ({ color = 'primary' }): JSX.Element => {
    return (
        <div className="cr-page-spinner">
            <Spinner animation="border" variant={color} />
        </div>
    );
};

export default PageSpinner;
